import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon4k: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-Icon4k"><Path d="M21.5 4.5H2.5V19.5H21.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.35107 16.0002V14.3887H5.29688V13.2937L8.73901 7.89746H10.5583V13.333H11.6758V14.3887H10.5583V16.0002H9.35107ZM6.46484 13.3499H9.3623V8.89136H9.32861L6.46484 13.3162V13.3499Z" fill="currentColor"/><Path d="M12.7483 16.0002V7.89746H14.0061V11.7776H14.0398L17.3079 7.89746H18.8015L15.73 11.48L19.0654 16.0002H17.51L14.8315 12.3391L14.0061 13.2937V16.0002H12.7483Z" fill="currentColor"/></CentralIconBase>;
});

export default Icon4k;
